<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" [innerHTML]="confirm?.header | safe: 'html'"></h5>
  </div>
  <div class="modal-body">
    <div class="confirm-message" [innerHTML]="confirm?.message | safe: 'html'"></div>
    <div class="confirm-list">
      <ul>
        @for (item of confirm?.messageList; track $index) {
          <li>{{ item }}</li>
        }
      </ul>
    </div>
  </div>
  <div class="modal-footer">
    @for (option of confirm?.confirmOptions; track option) {
      <button type="button" class="btn btn-default"
      (click)="action(option)" [innerHTML]="option.text | safe: 'html'"></button>
    }
  </div>
</div>